import React, {useEffect, useState} from "react";
import {sendFriendRequest} from "../clients/FriendClient";
import {FormField} from "../Views/MyProfile";
import PlusSymbol from "./svg/PlusSymbol";

const SendFriendRequestModal = ({successCallback, closeCallback}) => {
    const [friendRequestName, setFriendRequestName] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                closeCallback()
            }
        }

        window.addEventListener("keydown", handleEscape)

        return () => window.removeEventListener("keydown", handleEscape)
    }, [])

    const sendFriendInvite = (username) => {
        sendFriendRequest(username)
            .then(() => {
                setErrorMessage(null);
                successCallback();
            })
            .catch((e) => setErrorMessage(e.response?.data?.message || e.message))
    }

    return (
        <div className="modal-content"
             style={{
                 width: "auto",
                 position: "absolute",
                 left: "-3rem",
                 top: "-5rem",
                 maxWidth: "20rem",
                 display: "flex",
                 flexDirection: "column",
                 alignItems: "center",
                 paddingBottom: "0.5rem"
             }}>
            <button
                className="minimalist-button"
                style={{position: "absolute", top: "0", right: "0.25rem", fontSize: "1rem", padding: "0.2rem"}}
                onClick={closeCallback}
                aria-label="Close modal"
            >
                &times;
            </button>
            <h3 style={{marginTop: "0", marginBottom: "0"}}>Add Friend</h3>
            <FormField name="friendRequest" title="" value={friendRequestName}
                       onChange={(e) => setFriendRequestName(e.target.value)}/>
            <button onClick={() => sendFriendInvite(friendRequestName)} style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "0.5rem",
                padding: "0.5rem"
            }}>
                <PlusSymbol color="#fff" size="1rem" style={{marginRight: "0.2rem"}}/>
                <p style={{margin: "0", paddingRight: "0.5rem"}}>Add</p>
            </button>
            {errorMessage && <div className="info-message error"
                                  style={{width: "fit-content", padding: "1rem", marginTop: "0.5rem"}}>
                {errorMessage}
            </div>}
        </div>
    )
}

export default SendFriendRequestModal;